import { render, staticRenderFns } from "./RSelectItem.vue?vue&type=template&id=5d9bb9f5&scoped=true&"
import script from "./RSelectItem.vue?vue&type=script&lang=js&"
export * from "./RSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./RSelectItem.vue?vue&type=style&index=0&id=5d9bb9f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9bb9f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
